
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../common/Layout';
import { useRecipeDetail } from './useRecipeDetail';
import RecipeHeader from './RecipeHeader';
import IngredientsList from './IngredientsList';
import Instructions from './Instructions';
import Benefits from './Benefits';
import RecipeActionButton from './RecipeActionButton';
import LoadingState from './LoadingState';
import NotFoundState from './NotFoundState';
import { Alert, AlertTitle, AlertDescription } from '../ui/alert';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FoodDetailScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { recipe, ingredients, loading, consumed, error, handleConsume } = useRecipeDetail(id);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    console.log("FoodDetailScreen rendering with:", { id, loading, recipeExists: !!recipe, error });
  }, [id, loading, recipe, error]);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <Layout title="Error" showBackButton={true}>
        <Alert variant="destructive" className="mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
        <NotFoundState />
      </Layout>
    );
  }

  if (!recipe) {
    return <NotFoundState />;
  }
  
  // Selecciona los beneficios según el idioma
  const benefitsKey = `benefits_${i18n.language}` as keyof typeof recipe;
  const benefitsToDisplay = recipe[benefitsKey] as string[] || recipe.benefits;

  return (
    <Layout title={t('recipeDetail')} showBackButton={true}>
      <div className="pb-20">
        <RecipeHeader recipe={recipe} currentLang={i18n.language} />
        <IngredientsList ingredients={ingredients} currentLang={i18n.language} />
        <Instructions instructions={recipe?.['instructions_' + i18n.language] || recipe?.instructions} />
        <Benefits benefits={benefitsToDisplay} />
        <RecipeActionButton consumed={consumed} onConsume={handleConsume} />
      </div>
    </Layout>
  );
};

export default FoodDetailScreen;
